import React from "react";
import "./style/Style.css"; // Custom styles for loader

const FullScreenLoader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="fullscreen-loader" style={{ zIndex: "1111" }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default FullScreenLoader;
